import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { HibernationSchedule } from '@cast/types-cluster-autoscaler';

import { getHibernationSchedulesQueryKey } from 'hooks/queries/cluster-autoscaler/useGetHibernationSchedulesQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useCreateHibernationScheduleMutation = () => {
  const { currentOrganization } = useOrganizations();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (schedule: HibernationSchedule) => {
      return apiClient.clusterAutoscaler.createHibernationSchedule({
        organizationId: currentOrganization!.id,
        hibernationSchedule: schedule,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getHibernationSchedulesQueryKey(currentOrganization!.id),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
